<template lang="html">
  <div style="height:740px">
    <section role="dialog" tabindex="-1" aria-labelledby="modal-heading-01" aria-modal="true" aria-describedby="modal-content-id-1" class="slds-modal slds-fade-in-open">
      <div class="slds-modal__container">
        <header class="slds-modal__header">
          <button v-on:click.prevent="$emit('cancel')" class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Chiudi">
            <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
            </svg>
            <span class="slds-assistive-text">Chiudi</span>
          </button>
          <h2 id="modal-heading-01" class="slds-text-heading_medium slds-hyphenate">Nuovo Ticket</h2>
        </header>
        <div class="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
          <div class="slds-form" role="list">
          <formfield v-for="(f, findex) in fields"
            v-bind:key="f.id"
            v-bind:title="f.title"
            v-bind:type="f.type"
            v-bind:name="f.name"
            v-bind:value="f.value"
            v-bind:placeholder="f.placeholder"
            v-bind:tabindex="f.tabindex"
            v-bind:disabled="f.disabled"
            v-bind:options="f.options"
            v-on:change="$emit('change',{name:findex,value:$event})"
            />
        </div>
        </div>
        <footer class="slds-modal__footer">
          <button class="slds-button slds-button_neutral" v-on:click.prevent="$emit('cancel')">Cancel</button>
          <button class="slds-button slds-button_brand" v-on:click.prevent="$emit('submit')">Save</button>
        </footer>
      </div>
    </section>
    <div class="slds-backdrop slds-backdrop_open"></div>
  </div>
</template>

<script>
import formfield from './formfield.vue'

export default {
  name: 'ticket',
  components: {
    formfield
  },
  props: {
    fields: Array
  },
  data() {
    return {
    }
  },
  computed: {

  },
  async created() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>
